import { ReactNode } from 'react';
import styles from './mobile_footer.module.scss';

export interface MobileFooterProps {
  primaryButton: ReactNode;
  secondaryButton: ReactNode;
}

/**
 * Mobile footer layout component
 * Displays action buttons at the bottom of the screen
 * Slides up when header is sticky or modal is open
 */
const MobileFooter = ({
  primaryButton,
  secondaryButton,
}: MobileFooterProps) => {
  return (
    <div className={styles.footerNav} data-testid="cta-subnav-mobile-footer">
      {secondaryButton}
      {primaryButton}
    </div>
  );
};

export default MobileFooter;
